"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const CategoryMapComponent_1 = __importDefault(require("./CategoryMapComponent"));
const ColorSchemeFactory_1 = __importDefault(require("../ColorSchemeFactory"));
const ColorPaletteCollectionComponent_1 = __importDefault(require("./ColorPaletteCollectionComponent"));
const AxisBuilder_1 = __importDefault(require("./AxisBuilder"));
const immer_1 = __importDefault(require("immer"));
// Color editor for axis. Allows switching between editing individial colors (using CategoryMapComponent)
// and setting the colors from a palette (using ColorPaletteCollectionComponent)
class AxisColorEditorComponent extends react_1.default.Component {
    static defaultProps = {
        reorderable: false,
        autosetColors: true
    };
    constructor(props) {
        super(props);
        this.state = {
            mode: "normal"
        };
    }
    componentDidMount() {
        this.updateColorMap();
    }
    componentDidUpdate() {
        this.updateColorMap();
    }
    // Update color map if categories no longer match
    updateColorMap() {
        const axisBuilder = new AxisBuilder_1.default({ schema: this.props.schema });
        // If no categories, can't do anything
        if (!this.props.categories) {
            return;
        }
        // If no color map or color map values have changed
        if (!this.props.axis.colorMap ||
            !lodash_1.default.isEqual(lodash_1.default.pluck(this.props.axis.colorMap, "value").sort(), lodash_1.default.pluck(this.props.categories, "value").sort())) {
            let colorMap;
            if (this.props.autosetColors) {
                // Find categories that are not in the color map
                const missingCategories = lodash_1.default.filter(this.props.categories, (category) => !(this.props.axis.colorMap || []).find(cm => cm.value === category.value));
                if (missingCategories.length == 0) {
                    return;
                }
                const missingColorMap = ColorSchemeFactory_1.default.createColorMapForCategories(missingCategories, axisBuilder.isCategorical(this.props.axis));
                colorMap = (this.props.axis.colorMap || []).concat(missingColorMap);
                // If there are categories present, remove any color map values that are not in the categories
                if (this.props.categories.length > 0) {
                    colorMap = lodash_1.default.filter(colorMap, (cm) => this.props.categories.find((c) => c.value === cm.value));
                }
            }
            else {
                // Keep existing
                const existing = lodash_1.default.indexBy(this.props.axis.colorMap || [], "value");
                colorMap = lodash_1.default.map(this.props.categories, (category) => ({
                    value: category.value,
                    color: existing[category.value] ? existing[category.value].color : null
                }));
            }
            this.handlePaletteChange(colorMap);
            this.setState({ mode: "normal" });
        }
    }
    handleSelectPalette = () => {
        this.setState({ mode: "palette" });
    };
    handleResetPalette = () => {
        // Completely reset
        const colorMap = lodash_1.default.map(this.props.categories || [], (category) => ({
            value: category.value,
            color: null
        }));
        this.handlePaletteChange(colorMap);
        this.setState({ mode: "normal" });
    };
    handlePaletteChange = (palette) => {
        this.props.onChange((0, immer_1.default)(this.props.axis, (draft) => {
            draft.colorMap = palette;
            draft.drawOrder = lodash_1.default.pluck(palette, "value");
        }));
        this.setState({ mode: "normal" });
    };
    handleCancelCustomize = () => {
        this.setState({ mode: "normal" });
    };
    render() {
        return (react_1.default.createElement("div", null,
            this.state.mode === "palette" && this.props.categories && (react_1.default.createElement(ColorPaletteCollectionComponent_1.default, { onPaletteSelected: this.handlePaletteChange, axis: this.props.axis, categories: this.props.categories, onCancel: this.handleCancelCustomize })),
            this.state.mode === "normal" && (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { className: "link-plain", onClick: this.handleSelectPalette }, T `Change color scheme`),
                    !this.props.autosetColors && (react_1.default.createElement("a", { className: "btn btn-sm btn-link", onClick: this.handleResetPalette }, T `Reset colors`))),
                this.props.axis.colorMap && (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(CategoryMapComponent_1.default, { schema: this.props.schema, axis: this.props.axis, onChange: this.props.onChange, categories: this.props.categories, reorderable: this.props.reorderable, allowExcludedValues: this.props.allowExcludedValues, showColorMap: true, initiallyExpanded: this.props.initiallyExpanded }))))))));
    }
}
exports.default = AxisColorEditorComponent;
